/**
 * @file
 * A JavaScript file containing the activate-target functionality
 */

(function (Drupal, $) {
  Drupal.behaviors.activateTarget = {
    attach: function (context) {
      "use strict";

      $(once("activate-processed", ".activate", context))
        .addClass("activate-processed")
        .each(function () {
          if ($(this).is("option")) {
            var href = $(this).attr("value");
            $(this).attr("data-target", href);
          } else {
            var href = $(this).attr("href");
            $(this).attr("href", "#");
            $(this).data("target", href);
          }
          if ($(this).is("option")) {
            var $this = $(this);
            $(this)
              .parent()
              .change(function () {
                var target = this.value;
                if (target.indexOf("#") == 0) {
                  var toggleClass = "active";
                  if (typeof $this.data("class-toggle") !== "undefined") {
                    toggleClass = $this.data("class-toggle");
                  }
                  $(target).removeClass(toggleClass);
                }
              });
          } else {
            $(this).on("click", function (event) {
              event.preventDefault();

              var toggleClass = "active";
              if (typeof $(this).data("class-toggle") !== "undefined") {
                toggleClass = $(this).data("class-toggle");
              }
              var target = $(this).data("target");
              $(target).toggleClass(toggleClass);

              // if need to scroll and element active, scroll to it
              if (
                $(this).hasClass("activate-scroll") &&
                $(target).hasClass(toggleClass)
              ) {
                $([document.documentElement, document.body]).animate(
                  {
                    scrollTop: $(target).offset().top - 40,
                  },
                  1000
                );
              }
            });
          }
        });
    },
  };
})(Drupal, jQuery);
